import * as React from 'react';
import clsx from 'clsx';
import { Primitive } from '@radix-ui/react-primitive';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ":root{--loading-black:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' color='gray'><circle opacity='.25' cx='12' cy='12' r='10' stroke='currentColor' stroke-width='4'></circle><path opacity='.75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path></svg>\");--loading-white:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' color='white'><circle opacity='.25' cx='12' cy='12' r='10' stroke='currentColor' stroke-width='4'></circle><path opacity='.75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path></svg>\")}.Button-module_button__2XY0a{display:flex;align-items:center;justify-content:center;border-radius:.5rem;font-weight:500;border:none;cursor:pointer;transition:.3s cubic-bezier(.075,.82,.165,1);-webkit-appearance:none;-moz-appearance:none;appearance:none}.Button-module_button__2XY0a:hover{transition:.3s cubic-bezier(.075,.82,.165,1);opacity:.7}.Button-module_button__2XY0a[aria-disabled=true].Button-module_solid__3zVlV{cursor:not-allowed;background-color:#cacccf}.Button-module_button__2XY0a[aria-disabled=true]{cursor:not-allowed;opacity:.5}.Button-module_fullWidth__2gRWf{width:100%}.Button-module_xs__J0j54{padding:.25rem .5rem;font-size:.75rem;line-height:1rem}.Button-module_sm__33Zsf{padding:.25rem .75rem;font-size:.875rem;line-height:1.25rem}.Button-module_md__2Rj7-{padding:.5rem 1rem;font-size:1rem;line-height:1.5rem}.Button-module_lg__2e-NU{padding:.5rem 1.5rem;font-size:1.125rem;line-height:1.75rem}.Button-module_blue__3SQmW{--accentColor:#0087c8;--textColor:#fff;background-color:#0087c8}.Button-module_orange__2A1Ca{--accentColor:#f66951;--textColor:#fff;background-color:#f66951}.Button-module_outline__2OHZU{--loading-indicator:var(--loading-black);background-color:transparent;color:var(--accentColor);border:1px solid;border-color:var(--accentColor)}.Button-module_solid__3zVlV{--loading-indicator:var(--loading-white);color:var(--textColor)}.Button-module_ghost__4Ecz0{--loading-indicator:var(--loading-black);background-color:transparent;color:var(--accentColor)}.Button-module_loading__2-2Q0{background:var(--loading-indicator) no-repeat 50%;margin-right:1rem;height:20px;width:20px;-webkit-animation:Button-module_spin__KiUD8 1s linear infinite;animation:Button-module_spin__KiUD8 1s linear infinite}@-webkit-keyframes Button-module_spin__KiUD8{to{transform:rotate(1turn)}}@keyframes Button-module_spin__KiUD8{to{transform:rotate(1turn)}}";
var styles = {"button":"Button-module_button__2XY0a","solid":"Button-module_solid__3zVlV","fullWidth":"Button-module_fullWidth__2gRWf","xs":"Button-module_xs__J0j54","sm":"Button-module_sm__33Zsf","md":"Button-module_md__2Rj7-","lg":"Button-module_lg__2e-NU","blue":"Button-module_blue__3SQmW","orange":"Button-module_orange__2A1Ca","outline":"Button-module_outline__2OHZU","ghost":"Button-module_ghost__4Ecz0","loading":"Button-module_loading__2-2Q0","spin":"Button-module_spin__KiUD8"};
styleInject(css_248z);

var DESCRIPTION_NAME = 'Button';
var DESCRIPTION_DEFAULT_TAG = 'button';
var Button = React.forwardRef(function (props, ref) {
    var _a = props.as, as = _a === void 0 ? DESCRIPTION_DEFAULT_TAG : _a, className = props.className, _b = props.color, color = _b === void 0 ? 'blue' : _b, _c = props.size, size = _c === void 0 ? 'md' : _c, _d = props.variant, variant = _d === void 0 ? 'solid' : _d, _e = props.isLoading, isLoading = _e === void 0 ? false : _e, _f = props.fullWidth, fullWidth = _f === void 0 ? false : _f, _g = props.disabled, disabled = _g === void 0 ? false : _g, onClick = props.onClick, children = props.children, buttonProps = __rest(props, ["as", "className", "color", "size", "variant", "isLoading", "fullWidth", "disabled", "onClick", "children"]);
    var classes = clsx(styles.button, styles[color], styles[size], styles[variant], fullWidth && styles.fullWidth, className);
    function handleClick(event) {
        var isDisabled = event.target.getAttribute('aria-disabled') ===
            'true';
        if (isDisabled) {
            return;
        }
        onClick && onClick(event);
    }
    return (React.createElement(Primitive, __assign({ type: "button", className: classes, ref: ref, as: as, "aria-disabled": disabled, onClick: handleClick }, buttonProps),
        isLoading && React.createElement("span", { className: styles.loading, "aria-hidden": true }),
        children));
});
Button.displayName = DESCRIPTION_NAME;

export { Button };
